import * as Sentry from '@sentry/browser';
import { HttpRequestService } from '@shared/HttpRequestService';
async function GetSentryConfig() {
    const sentryConfig = {
        environment: '',
        dsn: ''
    };
    const response = await HttpRequestService.getRequest('/Shared/Settings/Sentry');
    if (response.ok) {
        const apiResponse = await response.json();
        sentryConfig.environment = apiResponse.Environment;
        sentryConfig.dsn = apiResponse.Dsn;
    }
    return sentryConfig;
}
const sentryConfig = await GetSentryConfig();
Sentry.init(sentryConfig);
